import type { MissionCandidate } from "./types";
import { entryEligibilityLabel } from '../shared/landing-card';

export type CandidateUnitFilter = "ALL" | "COMPOSITE" | "STRUCTURAL";

export function missionUnitLabel(unit: MissionCandidate["organizationUnit"]) {
  if (unit === "COMPOSITE") return "Kompozit";
  if (unit === "STRUCTURAL") return "Yapısal";
  return null;
}

export function filterMissionCandidates(
  candidates: readonly MissionCandidate[],
  input: { unit: CandidateUnitFilter; search: string; showUnsuitable: boolean },
) {
  const search = input.search.trim().toLocaleLowerCase("tr-TR");
  return candidates.filter((candidate) => {
    if (candidate.role !== "employee") return false;
    if (!missionUnitLabel(candidate.organizationUnit)) return false;
    if (input.unit !== "ALL" && candidate.organizationUnit !== input.unit) return false;
    if (!input.showUnsuitable && candidate.shiftGroup === "UNSUITABLE") return false;
    return !search || `${candidate.displayName} ${candidate.loginCode}`.toLocaleLowerCase("tr-TR").includes(search);
  });
}

export function candidateHasValidVisa(candidate: MissionCandidate) {
  return candidate.visaStatus === "VALID" || candidate.visaStatus === "SINGLE_ENTRY";
}

export function candidateHasLandingEntry(candidate: MissionCandidate) {
  return candidate.entryEligibility === 'LANDING_CARD' || candidate.entryEligibility === 'LANDING_CARD_CONDITIONAL';
}

function dateOnlyLabel(value: string) {
  const [year, month, day] = value.split("-");
  return year && month && day ? `${day}.${month}.${year}` : value;
}

export function candidateVisaLabel(candidate: MissionCandidate) {
  if (candidate.entryEligibility && ['LANDING_CARD','LANDING_CARD_CONDITIONAL','UNKNOWN'].includes(candidate.entryEligibility)) return entryEligibilityLabel(candidate.entryEligibility);
  if (candidate.visaStatus === "NOT_REQUIRED") return null;
  if (candidate.visaStatus === "NOT_YET_VALID") return "Vize görev tarihinde henüz başlamamış";
  if (candidateHasValidVisa(candidate) && candidate.visaValidUntil) {
    return `Vize geçerli — Bitiş: ${dateOnlyLabel(candidate.visaValidUntil)}`;
  }
  if (candidate.visaStatus === "EXPIRED" && candidate.visaValidUntil) {
    return `Vize süresi dolmuş — Bitiş: ${dateOnlyLabel(candidate.visaValidUntil)}`;
  }
  return "Bu ülke için kayıtlı geçerli vize yok";
}
